import { createSlice } from "@reduxjs/toolkit";

export default createSlice({
    name: "practiceExists",
    initialState: false,
    reducers: {
        set: (state, action) => action.payload,
    },
});
